<template>
  <div v-if="competitiveMarketItems.length">
    <b-table
      responsive
      striped
      bordered
      :fields="competitiveMarketFields"
      :items="competitiveMarketItems"
      class="fraudReportHeaderTable"
    >
    </b-table>
  </div>
</template>

<script>
export default {
  props: {
    climateData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      competitiveMarketItems: [],
      competitiveMarketFields: [
        {
          key: 'period',
          label: 'Period',
          class: 'text-left',
          thStyle: { textAlign: 'left',width: '100px' },
          tdClass: 'textTruncatee'
        },
        {
          key: 'estMonths',
          label: 'Est Months of Current Inventory',
          class: 'text-right',
          thStyle: { textAlign: 'right',width: '100px' },
          tdClass: 'textTruncatee'
        },
        {
          key: 'totalInventory',
          label: 'Total Inventory',
          class: 'text-right',
          thStyle: { textAlign: 'right',width: '100px' },
          tdClass: 'textTruncatee'
        },
        {
          key: 'average',
          label: 'Average # of Monthly Sales',
          class: 'text-right',
          thStyle: { textAlign: 'right',width: '100px' },
          tdClass: 'textTruncatee'
        },
        {
          key: 'averageDays',
          label: 'Average Days on Market',
          class: 'text-right',
          thStyle: { textAlign: 'right',width: '100px' },
          tdClass: 'textTruncatee'
        },
        {
          key: 'listPriceRange',
          label: 'List Price Range',
          class: 'text-left',
          thStyle: { textAlign: 'left',width: '100px' },
          tdClass: 'textTruncatee'
        },
        {
          key: 'salePriceRange',
          label: 'Sale Price Range',
          class: 'text-left',
          thStyle: { textAlign: 'left',width: '100px' },
          tdClass: 'textTruncatee'
        },
        {
          key: 'medianSalePrice',
          label: 'Median Sale Price',
          class: 'text-left',
          thStyle: { textAlign: 'left',width: '100px' },
          tdClass: 'textTruncatee'
        },
        {
          key: 'medianListPrice',
          label: 'Median List Price',
          class: 'text-left',
          thStyle: { textAlign: 'left',width: '100px' },
          tdClass: 'textTruncatee'
        },
        {
          key: 'percentageSpread',
          label: '% Spread Between Median List and Sale price',
          class: 'text-right',
          thStyle: { textAlign: 'right',width: '100px' },
          tdClass: 'textTruncatee'
        },
      ],
    }
  },
  mounted() {
    this.climateData.forEach((item) => {
      this.competitiveMarketItems.push({
        period: this.formatDisplay(item.period),
        estMonths: this.formatDisplay(item.estMonthsOfCurrentInventory),
        totalInventory: this.formatDisplay(item.totalInventory),
        average: this.formatDisplay(item.avgOfMonthlySales),
        averageDays: this.formatDisplay(item.avgDaysOfMarket),
        listPriceRange: this.formatDisplay(item.listPrice),
        salePriceRange: this.formatDisplay(item.salePrice),
        medianSalePrice: this.formatDisplay(item.medianSalePrice),
        medianListPrice: this.formatDisplay(item.medianListPrice),
        percentageSpread: this.formatDisplay(item.medianListAndSalePricePercent),
      })
    })
  },
  methods: {
    formatDisplay(value) {
      return value || null
    },
  }
}
</script>